import { ReactNode } from 'react'
import {
  FeaturedIconProps,
  FeaturedIcon,
  Typography,
  Containers,
  TypographyProps,
} from '@jisr-hr/ds'

export type AlertProps = {
  variant: 'info' | 'error' | 'warning' | 'success' | 'primary' | 'white'
  iconName?: string
  title?: string
  titleProps?: Omit<TypographyProps, 'text' | 'ref'>
  messageProps?: Omit<TypographyProps, 'text' | 'ref'>
  message?: string
  iconSize?: FeaturedIconProps['size']
  children?: ReactNode
  IsGridView?: boolean
}

const iconsVariant: Record<AlertProps['variant'], FeaturedIconProps['colorType']> = {
  error: 'error-dark',
  info: 'info-dark',
  warning: 'warning-dark',
  success: 'success-dark',
  primary: 'primary-dark',
  white: 'white',
}

const Alert = (props: AlertProps): JSX.Element => {
  const {
    iconName,
    message,
    title,
    variant,
    iconSize,
    titleProps = {},
    messageProps = {},
    children,
    IsGridView = true,
  } = props

  return (
    <Containers
      border
      borderRadius="sm"
      height="auto"
      width="auto"
      color={variant}
      styles={{
        gap: '16px',
        padding: '16px',
        display: 'grid',
        ...(IsGridView && { gridTemplateColumns: 'auto 1fr' }),
      }}
    >
      {iconName && (
        <FeaturedIcon
          iconName={iconName}
          size={iconSize ?? 'md'}
          colorType={iconsVariant[variant]}
        />
      )}
      <div>
        {title && (
          <Typography
            variant="subheading"
            text={title}
            style={{ fontWeight: 600 }}
            {...titleProps}
          />
        )}
        {message && (
          <Typography
            variant="body-new/regular"
            text={message}
            textColor="color/fg/light"
            {...messageProps}
          />
        )}
        {children}
      </div>
    </Containers>
  )
}

export default Alert
